import ExcelJS from "exceljs";
import { buildIndexSheet } from "./xbrl/sheets/indexSheet";
import { buildGenaralDisclosures } from "./xbrl/sheets/generalDisclosures";
import { buildStockExchangeSheet } from "./xbrl/sheets/stockExchangeSheet";
import { buildBusinessActivitiesSheet } from "./xbrl/sheets/businessActivitiesSheet";
import { buildProductsServicesSoldSheet } from "./xbrl/sheets/productsServicesSoldSheet";
import { buildHoldingSubsidiaryAssociateSheet } from "./xbrl/sheets/holdingSubsidiaryAssociateSheet";
import { buildBusinessConductIssuesSheet } from "./xbrl/sheets/businessConductIssuesSheet";
import { buildMgtAndProcessDisclosureSheet } from "./xbrl/sheets/mgtAndProcessDisclosureSheet";
import { buildPrinciple1Sheet } from "./xbrl/sheets/principle1Sheet";
import { buildPenaltyOrFineSheet } from "./xbrl/sheets/penaltyOrFineSheet";
import { buildSettlementSheet } from "./xbrl/sheets/settlementSheet";
import { buildCompoundingFeeSheet } from "./xbrl/sheets/compoundingFeeSheet";
import { buildImprisonmentSheet } from "./xbrl/sheets/imprisonmentSheet";
import { buildPunishmentSheet } from "./xbrl/sheets/punishmentSheet";
import { buildAppealOrRevisionCaseSheet } from "./xbrl/sheets/appealOrRevisionCaseSheet";
import { buildProgrammesForValueChainSheet } from "./xbrl/sheets/programmesForValueChainSheet";
import { buildPrinciple2Sheet } from "./xbrl/sheets/principle2Sheet";
import { buildLifeCycleAssessmentSheet } from "./xbrl/sheets/lifeCycleAssessmentSheet";
import { buildActionTakenSheet } from "./xbrl/sheets/actionTakenSheet";
import { buildRecycledOrReusedInputSheet } from "./xbrl/sheets/recycledOrReusedInputSheet";
import { buildDetailsOfOtherWasteSheet } from "./xbrl/sheets/detailsOfOtherWasteSheet";
import { buildReclaimedSheet } from "./xbrl/sheets/reclaimedSheet";
import { buildPrinciple3Sheet } from "./xbrl/sheets/principle3Sheet";
import { buildOtherRetirementBenefitsSheet } from "./xbrl/sheets/otherRetirementBenefitsSheet";
import { buildPrinciple4Sheet } from "./xbrl/sheets/principle4Sheet";
import { buildStakeholderGroupSheet } from "./xbrl/sheets/stakeholderGroupSheet";
import { buildPrinciple5Sheet } from "./xbrl/sheets/principle5Sheet";
import { buildOtherAssessmentsSheet } from "./xbrl/sheets/otherAssessmentsSheet";
import { buildDetailsOfOtherValueChainSheet } from "./xbrl/sheets/detailsOfOtherValueChainSheet";
import { buildPrinciple6Sheet } from "./xbrl/sheets/principle6Sheet";
import { buildDetailsOfOtherAirEmissionsSheet } from "./xbrl/sheets/detailsOfOtherAirEmissionsSheet";
import { buildEnvironmentApprovalSheet } from "./xbrl/sheets/environmentApprovalSheet";
import { buildEnvironmentalImpactSheet } from "./xbrl/sheets/environmentalImpactSheet";
import { buildEnergyConsumedFromRenewableSheet } from "./xbrl/sheets/energyConsumedFromRenewableSheet";
import { buildEnergyConsumedFromNRSheet } from "./xbrl/sheets/energyConsumedFromNRSheet";
import { buildPlantInAreaOfWaterStressSheet } from "./xbrl/sheets/plantInAreaOfWaterStressSheet";
import { buildInitiativeToImproveResourceSheet } from "./xbrl/sheets/initiativeToImproveResourceSheet";
import { buildPrinciple7Sheet } from "./xbrl/sheets/principle7Sheet";
import { buildActionTakenOnIssueSheet } from "./xbrl/sheets/actionTakenOnIssueSheet";
import { buildPublicPolicyAdvocatesSheet } from "./xbrl/sheets/publicPolicyAdvocatesSheet";
import { buildPrinciple8Sheet } from "./xbrl/sheets/principle8Sheet";
import { buildDetailsOfSIASheet } from "./xbrl/sheets/detailsOfSIASheet";
import { buildDetailsOfBenefitsFromIPSheet } from "./xbrl/sheets/detailsOfBenefitsFromIPSheet";
import { buildDetailsOfCSRProjectSheet } from "./xbrl/sheets/detailsOfCSRProjectSheet";
import { buildDetailsOfCorrectiveActionIPSheet } from "./xbrl/sheets/detailsOfCorrectiveActionIPSheet";
import { buildProjectForRehabilitationSheet } from "./xbrl/sheets/projectForRehabilitationSheet";
import { buildActionToMitigateNegativeSIASheet } from "./xbrl/sheets/actionToMitigateNegativeSIASheet";
import { buildCsrInAspirationalDistrictsSheet } from "./xbrl/sheets/csrInAspirationalDistrictsSheet";
import { buildPrinciple9Sheet } from "./xbrl/sheets/principle9Sheet";
import { get } from "./api";
import { extractReportingYearFromBrsrGetResponse, fetchYearFromBrsrList } from "./brsrFinancialYearLabels";

const XBRL_FILE_BASE_NAME = "Business Responsibility & Sustainability Reporting";

function buildSheet(workbook, sheetName, buildFn) {
  try {
    buildFn(workbook);
  } catch (error) {
    throw new Error(`Failed building sheet "${sheetName}": ${error.message}`);
  }
}

async function fetchAllSections(id) {
  try {
    const response = await get(
      `/brsr/get/sections?id=${id}&BRSRSectionA=true&BRSRSectionB=true&BRSRSectionC=true&principle1=true&principle2=true&principle3=true&principle4=true&principle5=true&principle6=true&principle7=true&principle8=true&principle9=true`
    );

    const payload = response?.data?.data || response?.data || {};

    return {
      sectionA: payload?.BRSRSectionA || null,
      sectionB: payload?.BRSRSectionB || null,
      sectionC: payload?.BRSRSectionC || null,
      reportingYear:
        payload?.year ||
        extractReportingYearFromBrsrGetResponse(response) ||
        "",
    };
  } catch (error) {
    console.log(error);
    return {
      sectionA: null,
      sectionB: null,
      sectionC: null,
      reportingYear: "",
    };
  }
}

async function resolveReportingYear(id, fallback = "") {
  if (fallback) return fallback;
  try {
    return (await fetchYearFromBrsrList(get, id)) || "";
  } catch {
    return "";
  }
}

export async function downloadBrsrXbrlExcel(id) {

  const { sectionA, sectionB, sectionC, reportingYear } = await fetchAllSections(id);
  const year = await resolveReportingYear(id, reportingYear);

  const workbook = new ExcelJS.Workbook();
  buildSheet(workbook, "Index", (wb) => buildIndexSheet(wb));
  buildSheet(workbook, "General Disclosures", (wb) => buildGenaralDisclosures(wb, sectionA));
  buildSheet(workbook, "Stock exchange", (wb) => buildStockExchangeSheet(wb, sectionA));
  buildSheet(workbook, "Details of business activities", (wb) => buildBusinessActivitiesSheet(wb, sectionA));
  buildSheet(workbook, "Products services sold", (wb) => buildProductsServicesSoldSheet(wb, sectionA));
  buildSheet(workbook, "Holding,subsidiary or associate", (wb) => buildHoldingSubsidiaryAssociateSheet(wb, sectionA));
  buildSheet(workbook, "Business conduct issues", (wb) => buildBusinessConductIssuesSheet(wb, sectionA));
  buildSheet(workbook, "MGT and process disclosure", (wb) => buildMgtAndProcessDisclosureSheet(wb, sectionB));
  buildSheet(workbook, "PRINCIPLE 1", (wb) => buildPrinciple1Sheet(wb, sectionC, year));
  buildSheet(workbook, "Penalty or fine", (wb) => buildPenaltyOrFineSheet(wb, sectionC));
  buildSheet(workbook, "Settlement", (wb) => buildSettlementSheet(wb, sectionC));
  buildSheet(workbook, "Compounding fee", (wb) => buildCompoundingFeeSheet(wb, sectionC));
  buildSheet(workbook, "Imprisonment", (wb) => buildImprisonmentSheet(wb, sectionC));
  buildSheet(workbook, "Punishment", (wb) => buildPunishmentSheet(wb, sectionC));
  buildSheet(workbook, "Appeal or revision case", (wb) => buildAppealOrRevisionCaseSheet(wb, sectionC));
  buildSheet(workbook, "Programmes for value chain", (wb) => buildProgrammesForValueChainSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 2", (wb) => buildPrinciple2Sheet(wb, sectionC, year));
  buildSheet(workbook, "Life cycle assessment", (wb) => buildLifeCycleAssessmentSheet(wb, sectionC));
  buildSheet(workbook, "Action taken", (wb) => buildActionTakenSheet(wb, sectionC));
  buildSheet(workbook, "Recycled or reused input", (wb) => buildRecycledOrReusedInputSheet(wb, sectionC, year));
  buildSheet(workbook, "Details of other waste", (wb) => buildDetailsOfOtherWasteSheet(wb, sectionC, year));
  buildSheet(workbook, "Reclaimed", (wb) => buildReclaimedSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 3", (wb) => buildPrinciple3Sheet(wb, sectionC, year));
  buildSheet(workbook, "Other retirement benefits", (wb) => buildOtherRetirementBenefitsSheet(wb, sectionC, year));
  buildSheet(workbook, "PRINCIPLE 4", (wb) => buildPrinciple4Sheet(wb, sectionC));
  buildSheet(workbook, "Stakeholder group", (wb) => buildStakeholderGroupSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 5", (wb) => buildPrinciple5Sheet(wb, sectionC, year));
  buildSheet(workbook, "Other assessments", (wb) => buildOtherAssessmentsSheet(wb, sectionC));
  buildSheet(workbook, "Details of other value chain", (wb) => buildDetailsOfOtherValueChainSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 6", (wb) => buildPrinciple6Sheet(wb, sectionC, year));
  buildSheet(workbook, "Energy consumed from renewable", (wb) => buildEnergyConsumedFromRenewableSheet(wb, sectionC, year));
  buildSheet(workbook, "Energy consumed from NR", (wb) => buildEnergyConsumedFromNRSheet(wb, sectionC, year));
  buildSheet(workbook, "Details of other air emissions", (wb) => buildDetailsOfOtherAirEmissionsSheet(wb, sectionC, year));
  buildSheet(workbook, "Environment approval", (wb) => buildEnvironmentApprovalSheet(wb, sectionC));
  buildSheet(workbook, "Environmental impact", (wb) => buildEnvironmentalImpactSheet(wb, sectionC));
  buildSheet(workbook, "Plant in area of water stress", (wb) => buildPlantInAreaOfWaterStressSheet(wb, sectionC, year));
  buildSheet(workbook, "Initiative to improve resource", (wb) => buildInitiativeToImproveResourceSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 7", (wb) => buildPrinciple7Sheet(wb, sectionC));
  buildSheet(workbook, "Action taken on issue", (wb) => buildActionTakenOnIssueSheet(wb, sectionC));
  buildSheet(workbook, "Public policy advocates", (wb) => buildPublicPolicyAdvocatesSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 8", (wb) => buildPrinciple8Sheet(wb, sectionC, year));
  buildSheet(workbook, "Details of SIA", (wb) => buildDetailsOfSIASheet(wb, sectionC));
  buildSheet(workbook, "Project for rehabilitation", (wb) => buildProjectForRehabilitationSheet(wb, sectionC));
  buildSheet(workbook, "Action to mitigate negative SIA", (wb) => buildActionToMitigateNegativeSIASheet(wb, sectionC));
  buildSheet(workbook, "CSR in aspirational districts", (wb) => buildCsrInAspirationalDistrictsSheet(wb, sectionC));
  buildSheet(workbook, "Details of benefits from IP", (wb) => buildDetailsOfBenefitsFromIPSheet(wb, sectionC));
  buildSheet(workbook, "Details of corrective action IP", (wb) => buildDetailsOfCorrectiveActionIPSheet(wb, sectionC));
  buildSheet(workbook, "Details of CSR project", (wb) => buildDetailsOfCSRProjectSheet(wb, sectionC));
  buildSheet(workbook, "PRINCIPLE 9", (wb) => buildPrinciple9Sheet(wb, sectionC, year));

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${XBRL_FILE_BASE_NAME}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
